export const LAMINATED = 'laminated';
export const LAMINATED_TEMPERED = 'laminated-tempered';
export const TEMPERED = 'tempered';

export default [LAMINATED, LAMINATED_TEMPERED, TEMPERED];
